import { Component } from '@angular/core';
import { OrdersModule } from '../../../../orders/orders.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-order-editor-dashboard-page',
  standalone: true,
  imports: [LayoutModule, OrdersModule],
  templateUrl: './order-editor-dashboard-page.component.html',
})
export class OrderEditorDashboardPageComponent { }
